import { useLocalSearchParams } from 'expo-router';
import { useMemo } from 'react';
import { ScreenContainer, Spinner, YStack } from 'smoothie';

import { DocumentLinkList } from '../../investment/components/documents/DocumentLinkList';
import { useFormerMemberInvestmentDocuments } from '../hooks/useFormerMemberInvestmentDocuments';

export const FormerMemberInvestmentTaxForms = () => {
    const { apexAccountId } = useLocalSearchParams<{
        apexAccountId: string;
    }>();

    const {
        isLoading: isLoadingDocuments,
        data: accountDocuments,
        getDocumentDownloadUrl,
    } = useFormerMemberInvestmentDocuments(apexAccountId);

    const taxDocuments = useMemo(
        () => accountDocuments?.taxDocuments ?? [],
        [accountDocuments],
    );

    return (
        <ScreenContainer title="Tax forms" hasBackButton>
            <YStack
                width="100%"
                paddingHorizontal={32}
                gap={16}
                alignItems="flex-start"
            >
                {isLoadingDocuments ? (
                    <Spinner />
                ) : (
                    <DocumentLinkList
                        getDocumentDownloadUrl={getDocumentDownloadUrl}
                        accountDocuments={taxDocuments}
                        documentTypeName="tax forms"
                    />
                )}
            </YStack>
        </ScreenContainer>
    );
};
